import { computeCheckDigitForResourceId } from "./computeCheckDigitForResource";

const TR_ID_LENGTH = 11;
const TR_ID_REGEX =
  /^(?<prefix>[\s\S])(?<number>[\s\S]{9})(?<check_digit>[\s\S])$/;
const TR_ID_PREFIX_REGEX = /^D$/;
const TR_ID_NUMBER_REGEX = /^[A-Z0-9]{9}$/;
const TR_ID_CHECK_DIGIT_REGEX = /^\d$/;

/**
 * Validates a TR-ID and returns a specific error message for invalid parts.
 */
function isValidTrId(trId: string): true | string {
  if (trId.length !== TR_ID_LENGTH) {
    return "Die TR-ID muss genau 11 Zeichen lang sein.";
  }

  const match = TR_ID_REGEX.exec(trId);

  if (!match?.groups) return "Die TR-ID ist ungültig.";

  const { prefix, number, check_digit } = match.groups;

  if (!TR_ID_PREFIX_REGEX.test(prefix)) {
    return "Die TR-ID muss mit einem D beginnen.";
  }

  if (!TR_ID_NUMBER_REGEX.test(number)) {
    return "Der Nummernteil der TR-ID muss aus 9 Großbuchstaben oder Ziffern bestehen.";
  }

  if (!TR_ID_CHECK_DIGIT_REGEX.test(check_digit)) {
    return "Die Prüfziffer der TR-ID muss eine Ziffer sein.";
  }

  if (computeCheckDigitForResourceId(prefix + number) !== Number(check_digit)) {
    return "Die Prüfziffer der TR-ID ist ungültig.";
  }

  return true;
}

export { isValidTrId };
